import { isoZ, z } from 'my-zod'
import { vehicleLifecycleStatusEnum } from '../vehicle'
import { vehicleEventBaseFragment } from './vehicle-event-base-fragment'

export const vehicleEventNameEnum = z.enum([
  'ChangeLifecycleStatus',
  'ImeiAssigned',
  'OtherVehicleEvent',
  'VehicleSold',
  'SaleProcessed',
  'VehicleDisposed',
  'VehicleQuarantined'
])
export const VehicleEventNames = vehicleEventNameEnum.Values

export const ChangeVehicleLifecycleStatusEvent = vehicleEventBaseFragment.augment({
  eventName: z.literal('ChangeLifecycleStatus'),
  eventData: z.object({
    newLifecycleStatus: vehicleLifecycleStatusEnum
  })
})
export type ChangeVehicleLifecycleStatusEvent = z.infer<typeof ChangeVehicleLifecycleStatusEvent>

export const ImeiAssignedEvent = vehicleEventBaseFragment.augment({
  eventName: z.literal('ImeiAssigned'),
  eventData: z.object({
    vehicleImei: z.string()
  })
})
export type ImeiAssignedEvent = z.infer<typeof ImeiAssignedEvent>

const VehicleSoldEvent = vehicleEventBaseFragment.augment({
  eventName: z.literal('VehicleSold'),
  eventData: z.object({
    buyerId: z.number()
  })
})
export type VehicleSoldEvent = z.infer<typeof VehicleSoldEvent>

export const SaleProcessedEvent = vehicleEventBaseFragment.augment({
  eventName: z.literal('SaleProcessed'),
  eventData: z.object({
    saleDate: isoZ.date(),
    netSaleRevenue: z.number().gte(0)
  })
})
export type SaleProcessedEvent = z.infer<typeof SaleProcessedEvent>

export const VehicleDisposedEvent = vehicleEventBaseFragment.augment({
  eventName: z.literal('VehicleDisposed')
})
export type VehicleDisposedEvent = z.infer<typeof VehicleDisposedEvent>

export const VehicleQuarantinedEvent = vehicleEventBaseFragment.augment({
  eventName: z.literal('VehicleQuarantined'),
  eventData: z.object({
    quarantinedExpirationDate: isoZ.date()
  })
})
export type VehicleQuarantinedEvent = z.infer<typeof VehicleQuarantinedEvent>

export const OtherVehicleEvent = vehicleEventBaseFragment.augment({
  eventName: z.literal('OtherVehicleEvent')
})
export type OtherVehicleEvent = z.infer<typeof OtherVehicleEvent>

export const VehicleEvent = z.union([
  ChangeVehicleLifecycleStatusEvent,
  ImeiAssignedEvent,
  VehicleSoldEvent,
  SaleProcessedEvent,
  VehicleDisposedEvent,
  VehicleQuarantinedEvent,
  OtherVehicleEvent
])
export type VehicleEvent = z.infer<typeof VehicleEvent>
